"use client"
import styles from "./Sidebar.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChartLine,
  faWarehouse,
  faTabletAlt,
  faBoxOpen,
  faShieldAlt,
  faUsers,
  faFileAlt,
  faUnlink,
} from "@fortawesome/free-solid-svg-icons"

const Sidebar = ({ activeItem = "Dashboard", onItemClick, customNavItems }) => {
  // read user info for footer display
  const rawLocalUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || {}
    } catch {
      return {}
    }
  })()

  const userName =
    (rawLocalUser?.first_name || rawLocalUser?.name || "Admin") +
    (rawLocalUser?.last_name ? ` ${rawLocalUser.last_name}` : "")
  const userRole = (rawLocalUser?.account_roles?.[0]?.name || rawLocalUser?.role || "Super User")

  // If customNavItems is explicitly an empty array (limited Super User), show only Devices Distribution
  const isLimitedSuperUser = Array.isArray(customNavItems) && customNavItems.length === 0

  const mainItems = isLimitedSuperUser
    ? [{ id: "Devices Distribution", label: "Devices Distribution", icon: faChartLine }]
    : customNavItems && customNavItems.length > 0
    ? customNavItems
    : [
        { id: "Dashboard", label: "Dashboard", icon: faChartLine },
        { id: "Warehouses", label: "Warehouses", icon: faWarehouse },
        { id: "Devices", label: "Devices", icon: faTabletAlt },
        { id: "Orders", label: "Orders", icon: faBoxOpen },
        { id: "Warranty Tracking", label: "Warranty Tracking", icon: faShieldAlt },
      ]

  const managementItems = isLimitedSuperUser
    ? []
    : customNavItems && customNavItems.length > 0
    ? []
    : [
        { id: "Users", label: "Users", icon: faUsers },
        // { id: "Reports", label: "Reports", icon: faFileAlt },
        { id: "Delink Requests", label: "Delink Requests", icon: faUnlink },
      ]

  const handleItemClick = (itemId) => {
    if (onItemClick) {
      onItemClick(itemId)
    }
  }

  return (
    <div className={styles.sidebar}>
      <div className={styles.header}>
        <h1 className={styles.title}>TOCA Inventory</h1>
      </div>

      <nav className={styles.nav}>
        <div className={styles.section}>
          {!isLimitedSuperUser && !customNavItems && <h3 className={styles.sectionTitle}>Main</h3>}
          <ul className={styles.list}>
            {mainItems.map((item) => (
              <li key={item.id} className={styles.listItem}>
                <button
                  className={`${styles.navItem} ${activeItem === item.id ? styles.active : ""}`}
                  onClick={() => handleItemClick(item.id)}
                >
                  <FontAwesomeIcon icon={item.icon} className={styles.icon} />
                  <span>{item.label}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>

        {managementItems.length > 0 && (
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Management</h3>
            <ul className={styles.list}>
              {managementItems.map((item) => (
                <li key={item.id} className={styles.listItem}>
                  <button
                    className={`${styles.navItem} ${activeItem === item.id ? styles.active : ""}`}
                    onClick={() => handleItemClick(item.id)}
                  >
                    <FontAwesomeIcon icon={item.icon} className={styles.icon} />
                    <span>{item.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </nav>

      <div className={styles.footer}>
        <div className={styles.userInfo}>
          <div className={styles.avatar}>{userName ? userName.charAt(0) : "A"}</div>
          <div className={styles.userDetails}>
            <div className={styles.userName}>{userName || "Admin User"}</div>
            <div className={styles.userRole}>{userRole || "Super User"}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
